<template>
  <div class="unsubscribe">
    <div class="main-nav-wrap">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-navbar id="main-nav" class="px-0" toggleable="lg" type="light" variant="white" style="height:60px;">
              <b-navbar-brand to="/"><img src="/img/logo.png" alt="ARVID's logo" /></b-navbar-brand>
            </b-navbar>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="content-wrap" role="main">
      <b-container fluid>
        <b-row>
          <b-col class="p-4 mx-auto" cols="12" md="6" lg="4">
            <b-overlay :show="loading" variant="dark" :opacity="0.15" spinner-variant="primary">
              <b-card>
                <h2>Frameld ARVID-nyt</h2>
                <b-alert :variant="alertVariant" :show="alert !== null">{{alert}}</b-alert>
                <b-form @submit.prevent="unsubscribe()">
                  <b-form-group
                    id="email"
                    description="Indtast den emailadresse du ønsker at framelde ARVID-nyt"
                    label="Emailadresse"
                    label-for="input-email"
                  >
                    <b-form-input id="input-email" v-model="email" autocomplete="email" trim required></b-form-input>
                  </b-form-group>
                  <b-button variant="primary" type="submit" class="float-right">Frameld</b-button>
                </b-form>
              </b-card>
            </b-overlay>
            <b-button class="mt-4" variant="outline-primary" to="/">Til forsiden</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    email: '',
    alert: null,
    alertVariant: 'danger',
    loading: false
  }),
  methods: {
    unsubscribe() {
      this.loading = true
      this.axios.post('/api/newsletters/actions/unsubscribe', {
        email: this.email
      }).then(() => {
        this.loading = false
        this.email = ''
        this.alert = 'Du er nu frameldt ARVID-nyt'
        this.alertVariant = 'success'
      }).catch((error) => {
        this.loading = false
        if (error.response.data.error) {
          this.alert = 'Der opstod en fejl. \n' + error.response.data.error + '\n Prøv igen senere.'
          this.alertVariant = 'danger'
        } else {
          this.alert = 'Der opstod en fejl. \n' + error.response.data + '\n Prøv igen senere.'
          this.alertVariant = 'danger'
        }
      })
    }
  }
}
</script>

<style>

</style>